import BoxWrapper from "../../../components/ui/BoxWrapper";
import Pagination from "../../../components/ui/Pagination";
import RenderTable from "../../../components/ui/RenderTable";
import { BookingSvg } from "../../../components/ui/SideBarMenu";
import { pluralize } from "../../../helpers/general";
import { useBookingQuery } from "../../../hooks/bookings/useBookingQuery";
import { general } from "../../../locales/general";
import BookingTable from "./BookingsTable";

const PAGE_SIZE = 10;

export default function PlaceManagerBookings() {
  const {
    bookings,
    fetchingBookings,
    totalItems,
    currentPage,
    setCurrentPage,
    isPreviousData,
    totalCount,
  } = useBookingQuery();

  return (
    <section>
      <h5 className="fs-4 fw-bold mb-2">Réservation</h5>
      <BoxWrapper>
        <div className="d-flex flex-column-reverse flex-md-row  justify-content-end">
          <div className="d-flex align-items-center justify-content-between">
            <div
              className="d-flex align-items-center justify-content-center gap-3 bg-gradient-primary p-3 w-100"
              style={{ borderTopRightRadius: "8px" }}
            >
              <BookingSvg className="fill-white" />
              <p className="fs-5 fw-bold m-0  text-white">
                {totalCount} {pluralize("Réservation", totalCount)}
              </p>
            </div>
          </div>
        </div>

        <RenderTable
          loading={fetchingBookings || isPreviousData}
          render={() =>
            bookings?.length > 0 ? (
              <BookingTable bookings={bookings} />
            ) : (
              <p className="text-center fs-5 my-2">{general.fr.noData}</p>
            )
          }
        />
      </BoxWrapper>
      <Pagination
        currentPage={currentPage}
        onPageChange={(page) => {
          setCurrentPage(page);
        }}
        siblingCount={1}
        totalCount={totalItems}
        pageSize={PAGE_SIZE}
      />
    </section>
  );
}
